import { Chain } from 'viem';
import {
  beam,
  beamTestnet,
  immutableZkEvm,
  immutableZkEvmTestnet,
  sophon,
  sophonTestnet,
} from 'viem/chains';

export const customChains = {
  beam,
  beamTestnet,
  immutableZkEvm,
  immutableZkEvmTestnet,
  sophon,
  sophonTestnet,
} as const satisfies Record<string, Chain>;
